import { render, staticRenderFns } from "./SliderPage.vue?vue&type=template&id=32580ed5&scoped=true&"
import script from "./SliderPage.vue?vue&type=script&lang=js&"
export * from "./SliderPage.vue?vue&type=script&lang=js&"
import style0 from "./SliderPage.vue?vue&type=style&index=0&id=32580ed5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32580ed5",
  null
  
)

export default component.exports